const pharmacistsCountPlaceholders = document.querySelectorAll('.pharmacist-count');

if (pharmacistsCountPlaceholders.length > 0) {
    setPharmacistsCount();
}

async function setPharmacistsCount() {
    const response = await fetch('/Pharmacy/GetAllPharmacistsCount');
    const result = await response.json();

    if (result.data !== -1) {
        pharmacistsCountPlaceholders.forEach(element => {
            element.innerHTML = result.data;
        })
    }
}